import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

const PRODUCT_CODE = 'Prospecting'

// Configure request setup
const serviceName = 'ProspectingResellingService'
const host = servicesConfig.Reselling as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const ProspectingResellingService = {
  getProductConfiguration: () => 
    request().get(`/product?productCode=${PRODUCT_CODE}`).then(responseBody),

  getLocationConfig: (locationId: string) => 
    request().get(`/location/${locationId}`).then(responseBody),

  getCompanyConfig: (companyId: string) => 
    request().get(`/company/${companyId}`).then(responseBody),

  getLocationResellingConfig: (locationId: string) =>
    request().get(`/configuration/location/${locationId}/${PRODUCT_CODE}`).then(responseBody),
    
  getCompanyResellingConfig: (companyId: string) =>
    request().get(`/configuration/company/${companyId}/${PRODUCT_CODE}`).then(responseBody),

  updateCompanyResellingConfig: (
    companyId: string,
    data: {
      amount?: number
      offeringEnabled?: boolean
      companyCustomFields?: object
      plans?: { planId: string; amount: number; meta?: any }[]
    }
  ) => request().put(`/configuration/company/${companyId}/${PRODUCT_CODE}`, data).then(responseBody),

  updateLocationResellingConfig: (
    locationId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] }
  ) => request().put(`/configuration/location/${locationId}/${PRODUCT_CODE}`, data).then(responseBody),

  getLocationSubscriptions: (locationId: string) =>
    request().get(`/subscription/location/${locationId}?productCode=${PRODUCT_CODE}`).then(responseBody),

  createAgencyDirectSubscription: (locationId: string, planId: string) =>
    request().post(`/subscription/location/${locationId}/${PRODUCT_CODE}`, {
      purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
      planId,
    }).then(responseBody)
}

export default ProspectingResellingService
